import { graphql } from '@gql';

export const VildarIframeSectionFragment = graphql(/* GraphQL */ `
  fragment VildarIframeSectionFragment on VildarPageComponentsForms {
    __typename
    forms {
      iframe_type
      iframe_url {
        href
        title
      }
    }
  }
`);
